export const urls = {
  allianzUrl:
    "https://www.allianzlife.com/what-we-offer/annuities/fixed-index-annuities/lifetime-income-plus-ijoin",
};
